import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Statistic } from 'semantic-ui-react'

import styles from './index.css'

class StatsList extends PureComponent {
  render() {
    const { className, stats } = this.props

    return (
      <div className={classnames(styles.wrapper, className)}>
        <Statistic.Group size="small">
          {stats.map((stat) => (
            <Statistic key={stat.name} className={styles.stat}>
              <Statistic.Value>{stat.value.toLocaleString()}</Statistic.Value>
              <Statistic.Label>{stat.name}</Statistic.Label>
            </Statistic>
          ))}
        </Statistic.Group>
      </div>
    )
  }
}

StatsList.propTypes = {
  className: PropTypes.string,
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number,
    }),
  ).isRequired,
}

StatsList.defaultProps = {
  className: null,
}

export default StatsList
